module.exports = __webpack_public_path__ + "da809192882a4a82b5d262f0522a25e3.svg";